import gql from 'graphql-tag';

export default gql`
  mutation removeRelatedProject($projectId: Int!) {
    relatedProjectRemove(projectId: $projectId)
  }
`;
